import { getAllConnectors, createOrUpdateConnector, getConnectorDetail, deleteMultipleConnectors } from '../api'

export const loadAllConnectors = ({ state, commit }, { page, count }) => {
  return getAllConnectors(page, count)
}

export const createConnector = ({ state, commit }, connector) => {
  return createOrUpdateConnector(connector)
}

export const loadConnectorDetail = ({ state, commit }, uuid) => {
  return getConnectorDetail(uuid)
}

export const deleteConnectors = ({ state, commit }, itemsToDelete) => {
  return deleteMultipleConnectors(itemsToDelete)
}



// WEBPACK FOOTER //
// ./src/app/connector/vuex/actions.js